export {default as FileSelect} from "./FileSelect";
export {default as TextField} from "./TextField";
export {default as Password} from "./Password";
export {default as Textarea} from "./Textarea";
export {default as Select} from "./Select";
export {default as Button} from "./Button";

export * from "./Input";

export interface FieldProps {
    label?: string;
    placeholder?: string;
    value?: any;
    className?: string;
    onChange: (value: any, oldValue: any) => void;
}
